/**
 * Environment Badge Component
 * Shows current environment in non-production environments
 */

import { getEnvironmentConfig } from '@schoolidb/config';

export function EnvironmentBadge() {
  const config = getEnvironmentConfig();
  
  // Don't show in production
  if (config.name === 'production') {
    return null;
  }

  const bgColor = config.name === 'development' ? 'bg-yellow-500' : 'bg-orange-500';

  return (
    <div className={`fixed bottom-4 left-4 ${bgColor} text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg z-50`}>
      {config.name.toUpperCase()}
    </div>
  );
}
